import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TranslatedTextError } from 'src/components';
import { Loading } from 'src/components/Loading';
import { StepsIndicator } from 'src/components/StepsIndicator';
import { SText } from 'src/components/SText';
import { FooterActions } from '../../containers/FooterActions';
import {
  eStoreFormStateSelector,
  eStoreSenderIsNotReceiverSelector,
  eStoreSubmitDataErrorSelector,
  eStoreSubmitDataIsLoadingSelector,
  eStoreSubmitDataSuccessSelector,
  startSubmitEStoreFormData,
} from '../store';
import { EStoreRecapContent } from './EStoreRecapContent';

type Props = {
  testID?: string;
  parentUrl: string;
};

export const EStoreRecap: React.FC<Props> = ({ parentUrl, testID = 'EStoreRecap' }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const senderIsNotReceiver = useSelector(eStoreSenderIsNotReceiverSelector);
  const eStoreForm = useSelector(eStoreFormStateSelector);

  const isSubmittingData = useSelector(eStoreSubmitDataIsLoadingSelector);
  const isSubmittingError = useSelector(eStoreSubmitDataErrorSelector);

  const isSuccessSubmitData = useSelector(eStoreSubmitDataSuccessSelector);

  useEffect(() => {
    if (isSuccessSubmitData) {
      history.replace(`${parentUrl}/success`);
    }
  }, [isSuccessSubmitData, parentUrl, history]);

  useEffect(() => {
    if ((!eStoreForm.sender.tel || !eStoreForm.toAgency) && !isSubmittingData) {
      history.replace(`${parentUrl}/`);
    }
  }, [eStoreForm, history, parentUrl, isSubmittingData]);

  const onPreview = useCallback(() => {
    history.goBack();
  }, [history]);

  const onValidSubmitCreate = useCallback(() => {
    dispatch(startSubmitEStoreFormData());
  }, [dispatch]);

  if (isSubmittingData) {
    return <Loading />;
  }

  return (
    <div className="h-screen py-3 md:h-auto md:mt-0 mt-6 w-full relative">
      <StepsIndicator totalSteps={senderIsNotReceiver ? 4 : 3} active={senderIsNotReceiver ? 3 : 2} />
      <SText label="estore-recap.page-title" classNames="my-4 text-primary block text-lg text-center font-semibold" />
      <div>
        <EStoreRecapContent recapInfos={eStoreForm} />
      </div>

      {!!isSubmittingError && <TranslatedTextError message={isSubmittingError.message} />}
      <FooterActions
        onPreview={onPreview}
        nextLabel="global.cta-valid"
        previewLabel="global.navigation-back"
        isNotSubmit
        onNext={onValidSubmitCreate}
      />
    </div>
  );
};
